import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import { useTranslate } from "react-admin";
import { styles } from "./styles";
import MenuItemLink from "../MenuItemLink";
import { SettingsIcon } from "../../icon_svg";

const MenuSettings = (props) => {
  const { onMenuClick } = props;

  const translate = useTranslate();
  return (
    <Fragment>
      <MenuItemLink
        to={`/codes`}
        primaryText={translate(`resources.menus.settings`, {
          smart_count: 2,
        })}
        onClick={onMenuClick}
        translate={translate}
        leftIcon={<SettingsIcon />}
      />
    </Fragment>
  );
};

export default withStyles(styles)(MenuSettings);
